import { render, staticRenderFns } from "./LongEssayReviewActionItem.vue?vue&type=template&id=6fce3ae1&scoped=true&"
import script from "./LongEssayReviewActionItem.vue?vue&type=script&lang=js&"
export * from "./LongEssayReviewActionItem.vue?vue&type=script&lang=js&"
import style0 from "./LongEssayReviewActionItem.vue?vue&type=style&index=0&id=6fce3ae1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce3ae1",
  null
  
)

export default component.exports